import axios from 'axios';

export async function init({ commit, dispatch }) {
	try {
		await dispatch('getSource');
	} catch (error) {
		if (!error.handled && error.response.status !== 404) {
			console.error(error);
		}
	}
	commit('INIT');
}


// payment source/method
export async function setSource({ state }, source) {
	source = source || state.source;
	await axios.post('/subscription/payment_source', { source });
}

export async function getSource({ commit, dispatch }) {
	const { data } = await axios.get('/subscription/payment_source');

	commit('UPDATE_SUBSCRIPTION', {
		type: data.type,
		cancellationDate: data.cancellationDate,
	});

	if (data.type === 'sepa_debit') {
		commit('UPDATE_SUBSCRIPTION', {
			accountHolder: data.sepa_debit.owner,
			last4: data.sepa_debit.last4,
		});
	}

	await dispatch('auth/getUser', null, { root: true });
}


// invoice
export async function getInvoices({ commit }) {
	try {
		commit('SET_INVOICES_LOADING', true);
		const { data } = await axios.get('/subscription/invoices');
		commit('SET_INVOICES', data);
		commit('SET_INVOICES_LOADING', false);
	} catch (error) {
		if (!error.handled && error.response.status !== 404) {
			console.error(error);
		}
	}
}

export async function getInvoiceDetails(_, { periodStart, periodEnd, invoiceId }) {
	const { data: pdf } = await axios.get(`/subscription/invoices/${invoiceId}/details`, {
		responseType: 'blob',
		params: {
			start: periodStart,
			end: periodEnd,
		},
	});
	return pdf;
}


// subscription
export async function createSubscription({ dispatch }, payload) {
	await axios.post('/subscription', payload);
	await dispatch('auth/getUser', null, { root: true });
}


// offer
export async function requestOffer({ dispatch }, payload) {
	await axios.post('/offer/request', payload);
	await dispatch('auth/getUser', null, { root: true });
}

export async function getOffer({ commit }) {
	const { data } = await axios.get('/offer');
	commit('UPDATE_SUBSCRIPTION', {
		offer: data,
	});
}

export async function acceptOffer({ dispatch }) {
	await axios.post('/offer/subscription',);
	await dispatch('auth/getUser', null, { root: true });
}
